module.exports = __webpack_public_path__ + "img/de_bg_4.212929c3.jpeg";